import constants from './constants.js';
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';

export default {
    validateItem(i18n, validationRule, value, value2) {
        switch(validationRule) {
            case "departmentName":
                return this.departmentName(i18n, value);
            case "emailAddress":
                return this.adminEmailAddress(i18n, value);
            case "userEmailAddress":
                return this.userEmailAddress(i18n, value);
            case "multipleEmailAddress":
                return this.multipleEmailAddress(i18n, value);
            case "loginId":
                return this.loginId(i18n, value);
            case "zip":
                return this.zip(i18n, value);
            case "addressPref":
                return this.addressPref(i18n, value);
            case "address1":
                return this.address1(i18n, value);
            case "address2":
                return this.address2(i18n, value);
            case "phoneNumber":
                return this.phoneNumber(i18n, value, value2);
            case "reqPhoneNumber":
                return this.reqPhoneNumber(i18n, value, value2);
            case "mobilePhoneNumber":
                return this.mobilePhoneNumber(i18n, value, value2);
            case "countryCode":
                return this.countryCode(i18n, value);
            case "domainName":
                return this.domainName(i18n, value);
            case "userId":
                return this.userId(i18n, value);
            case "objectId":
                return this.objectId(i18n, value);
            case "password":
                return this.password(i18n, value);
            case "passwordNotRequired":
                return this.passwordNotRequired(i18n, value);
            case "confirmPassword":
                return this.confirmPassword(i18n, value, value2);
            case "displayName":
                return this.displayName(i18n, value);
            case "reqDisplayName":
                return this.reqDisplayName(i18n, value);
            case "text":
                return this.text(i18n, value);
            case "text100":
                return this.text100(i18n, value);
            case "reqText":
                return this.reqText(i18n, value);
            case "reqText200":
                return this.reqText200(i18n, value);
            case "numeric":
                return this.numeric(i18n, value);
            case "selectItem":
                return this.selectItem(i18n, value);
            case "urlScheme":
                return this.urlScheme(i18n, value);
            case "urlSchemeAndroidPackage":
                return this.urlSchemeAndroidPackage(i18n, value);
            case "urlSchemeAndroidClass":
                return this.urlSchemeAndroidClass(i18n, value);
            case "reqAlphabetName":
                return this.reqAlphabetName(i18n, value);
            case "reqUrl":
                return this.reqUrl(i18n, value);
            case "url":
                return this.url(i18n, value);
            case "reqToken":
                return this.reqToken(i18n, value);
            case "halfWideLetter":
                return this.halfWideLetter(i18n, value);
            case "reqHalfWideLetter":
                return this.reqHalfWideLetter(i18n, value);
            case "reqFullKana":
                return this.reqFullKana(i18n, value);
            case "reqFullWordCharacterName":
                return this.reqFullWordCharacterName(i18n, value);
            case "filePathFormat":
                return this.storageFilePathFormat(i18n, value);
            case "melodyStamp":
                return this.melodyStamp(i18n, value);
            case "sttPhraseField":
                return this.sttPhraseField(i18n, value);
            case "reqSttPhraseField":
                return this.reqSttPhraseField(i18n, value);
            case "none":
                return { valid: true , message: "" };
            case "invalid":
                return { valid: false, message: "" };
            case "require":
                return this.require(i18n, value);
            case "requireArray":
                return this.requireArray(i18n, value);
            case "bellName":
                return this.bellName(i18n, value);
            case "bellDisplayName":
                return this.bellDisplayName(i18n, value);
            case "usagePoint":
                return this.usagePoint(i18n, value);
            case "usageTime":
                return this.usageTime(i18n, value);
            default:
                return {valid: true , message: ""};
        }
    },
    selectItem(i18n, value) {
        if (value == null) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_should_select")};
        } else {
            if (String(value) == "") {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_should_select")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    departmentName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_departmentName_not_found")};
        } else {
            if  (value.length > 50) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
            }
            if (!characterCheck.isValidForDisplayName(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_displayName")};
            } else {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            }
        }
    },
    adminEmailAddress(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForMailaddress(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_email")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    userEmailAddress(i18n, value) {
        // null or empty is allowed to user_attribute
        if (value == null || value.length == 0) {
            return {valid: true , message: ""};
        } else if (!characterCheck.isValidForMailaddress(value)) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_email")};
        } else {
            return {valid: true , message: ""};
        }
    },
    multipleEmailAddress(i18n, value) {
        // null or empty is allowed to user_attribute
        if (value == null || value.length == 0) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else if (!characterCheck.isValidForMailaddress(value)) {
            if (value.indexOf(";") < 0) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_email")};
            }
        }
        let mailAddressList = value.split(";");
        for (let mailAddress of mailAddressList) {
            if (mailAddress.indexOf("@") < 0) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_email")};
            }
        }
        return {valid: true , message: ""};
    },
    loginId(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_loginId_not_found")};
        } else {
            if (!characterCheck.isValidForMailaddress(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_loginId")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    zip(i18n, value, countryCode) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForZipCode(value, countryCode)) {
                if (countryCode == 'JPN') {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_zip1")};
                } else {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_zip2")};
                }
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    addressPref(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            return {valid: true , message: ""};
        }
    },
    address1(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length <= 32) {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            } else {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','32')};
            }
        }
    },
    address2(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length <= 127) {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            } else {
                return {valid: false , message: commonUtil.getMessageText(i18n,"error_validate_exceeds_string").replace('{CHAR_COUNT}','128')};
            }
        }
    },
    phoneNumber(i18n, value, countryCode) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (!characterCheck.isValidForPhoneNumber(value, countryCode)) {
                if (countryCode == "JPN") {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_PhoneNumber2")};
                } else {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_PhoneNumber1")};
                }
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    reqPhoneNumber(i18n, value, countryCode) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_phoneNumber_not_found")};
        } else {
            if (!characterCheck.isValidForPhoneNumber(value, countryCode)) {
                if (countryCode == "JPN") {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_PhoneNumber2")};
                } else {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_PhoneNumber1")};
                }
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    mobilePhoneNumber(i18n, value, countryCode) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_phoneNumber_not_found")};
        }
        if (characterCheck.isValidForMobilePhoneNumber(value, countryCode)) {
            return {valid: true , message: ""};
        }
        return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_PhoneNumber_mobile_JPN")};
    },
    countryCode(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            return {valid: true , message: ""};
        }
    },
    domainName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForDomainName(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_domainName")};
            } else {
                if (value.length > 50) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
                } else {
                    if (value.trim().length == 0) {
                        return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                    }
                    return {valid: true , message: ""};
                }
            }
        }
    },
    userId(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length > 50) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
            } else {
                if (!characterCheck.isValidForUserName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n,"error_invalid_userId")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    objectId(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length > 50) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
            } else {
                if (!characterCheck.isValidForGroupAndTalkgroupName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_cannot_use_space")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    password(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForPassword(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_password")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    passwordNotRequired(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (!characterCheck.isValidForPassword(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_password")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    confirmPassword(i18n, value,password) {
        if (!value) {
            if ((password == null) || (password =="")) {
                return {valid: true , message: ""};
            } else {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_password_not_matched")};
            }
        } else {
            if (value == password) {
                return {valid: true , message: ""};
            } else {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_password_not_matched")};
            }
        }
    },
    displayName(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (value.length > 50) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
            } else {
                if (!characterCheck.isValidForDisplayName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_displayName")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    reqDisplayName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length > 50) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
            } else {
                if (!characterCheck.isValidForDisplayName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_displayName")};
                } else {
                    if (value.trim().length == 0) {
                        return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                    }
                    return {valid: true , message: ""};
                }
            }
        }
    },
    text(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (!characterCheck.isValidForDisplayName(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_text")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    text100(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (value.length > 100) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','100')};
            } else {
                if (!characterCheck.isValidForDisplayName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_text")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    reqText(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForDisplayName(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_text")};
            } else {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            }
        }
    },
    reqText200(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length > 200) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','200')};
            } else {
                if (!characterCheck.isValidForDisplayName(value)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_text")};
                } else {
                    if (value.trim().length == 0) {
                        return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                    }
                    return {valid: true , message: ""};
                }
            }
        }
    },
    reqToken(i18n, value) {
        if (!value) {
            return { valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found") };
        } else {
            if (value.length > 65535) {
                return { valid: false, message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','65535') };
            } else {
                if (!characterCheck.isValidToken(value)) {
                    return { valid: false, message: commonUtil.getMessageText(i18n, "error_validate_invalid_half_wide_letter") };
                } else {
                    return { valid: true, message: "" };
                }
            }
        }
    },
    melodyStamp(i18n, value) {
        let stampValue;
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (value.length > 500) {
                return {valid: false, message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}', '500')};
            }
            if (value.indexOf("\"") === 0) {
                let separatedValue = value.split("\",");
                if (separatedValue.length !== 2) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_melody_stamp")};
                }
                stampValue = separatedValue[1];
            } else if (value.indexOf("\"") > 0) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_melody_stamp")};
            } else {
                stampValue = value;
            }
            if (!characterCheck.isValidForMelodyStamp(stampValue)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_melody_stamp")};
            } else {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            }
        }
    },
    halfWideLetter(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (!characterCheck.isValidForHalfWideLetter(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_half_wide_letter")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    reqHalfWideLetter(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForHalfWideLetter(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_half_wide_letter")};
            } else {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            }
        }
    },
    reqFullKana(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidFullKana(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_full_kana")};
            } else {
                if (value.trim().length === 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_invalid_no_characters")};
                }
                return {valid: true , message: ""};
            }
        }
    },
    numeric(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForNumeric(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_numeric")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    urlScheme(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForUrlScheme(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_urlScheme")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    urlSchemeAndroidPackage(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForUrlScheme(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_urlScheme")};
            } else {
                if (value.length > 50) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace("{CHAR_COUNT}","50")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    urlSchemeAndroidClass(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidForUrlScheme(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_urlScheme")};
            } else {
                if (value.length > 80) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace("{CHAR_COUNT}","80")};
                } else {
                    return {valid: true , message: ""};
                }
            }
        }
    },
    reqAlphabetName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidAlphabetName(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_alphabetName")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    reqFullWordCharacterName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidFullWordCharacter(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_alphabetName")};
            } else {
                return {valid: true , message: ""};
            }
        }
    },
    reqUrl(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        } else {
            if (!characterCheck.isValidUrl(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url")};
            } else {
                if (value.trim().length == 0) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
                }
                if (value.trim().length > 512) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url_max")};
                }
                if ((value.indexOf("http://") == 0) || (value.indexOf("https://") == 0)) {
                    return {valid: true , message: ""};
                } else {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url_format")};
                }
            }
        }
    },
    url(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        } else {
            if (!characterCheck.isValidUrl(value)) {
                return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url")};
            } else {
                if (value.trim().length > 512) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url_max")};
                }
                if ((value.indexOf("http://") == 0) || (value.indexOf("https://") == 0)) {
                    return {valid: true , message: ""};
                } else {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_url_format")};
                }
            }
        }
    },
    storageFilePathFormat(i18n, value) {
        if (characterCheck.isValidFilePathFormat(value)) {
            return {valid: true, message: ""};
        }
        return {valid: false, message: commonUtil.getMessageText(i18n, "error_validate_invalid_file_path_format")};
    },
    checkFormValidation(formValidationList) {
        for(var validateItem in formValidationList) {
            if (!formValidationList[validateItem].valid) {
                return false;
            }
        }
        return true;
    },
    sttPhraseField(i18n, value) {
        if (!value) {
            return {valid: true , message: ""};
        }
        if (value.length > 50) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
        }
        if (!characterCheck.isValidSttPhraseField(value)) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_stt_phrase_field")};
        }
        return {valid: true , message: ""};
    },
    reqSttPhraseField(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }
        if (value.length > 50) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}','50')};
        }
        if (!characterCheck.isValidSttPhraseField(value)) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_stt_phrase_field")};
        }
        return {valid: true , message: ""};
    },
    require(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }
        return {valid: true , message: ""};
    },
    requireArray(i18n, value) {
        if (value.length === 0) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_selected")};
        }
        return {valid: true , message: ""};
    },
    bellName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }
        if (value.length > constants.BELL_MAX_NAME_LENGTH) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}', constants.BELL_MAX_NAME_LENGTH)};
        }
        if (!characterCheck.isValidForBellName(value)) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_bell_name")};
        } else {
            return {valid: true , message: ""};
        }
    },
    bellDisplayName(i18n, value) {
        if (!value) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }
        if (value.length > constants.BELL_MAX_DISPLAY_NAME_LENGTH) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_exceeds_string").replace('{CHAR_COUNT}', constants.BELL_MAX_DISPLAY_NAME_LENGTH)};
        }
        if (!characterCheck.isValidForBellName(value)) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_bell_name")};
        } else {
            return {valid: true , message: ""};
        }
    },
    usagePoint(i18n, value) {
        if (!value.use) {
            return {valid: true , message: ""};
        }
        if (!value.latlng) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }

        const parts = value.latlng.split(',');
        if (parts.length === 2) {
            const latitude = parseFloat(parts[0].trim());
            const longitude = parseFloat(parts[1].trim());
            if (!isNaN(latitude) && !isNaN(longitude)) {
                if ((latitude < -90 || latitude > 90) || (longitude < -180 || longitude > 180)) {
                    return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_latlng_not_exists")};
                } else {
                    return {valid: true, message: ""};
                }
            }
        }

        return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_latlng_format")};
    },
    usageTime(i18n, value) {
        if (!value.use) {
            return {valid: true , message: ""};
        }
        if (!value.range.start || !value.range.end) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_not_found")};
        }

        if (value.range.start === value.range.end || (value.range.start === "00:00" && value.range.end === "24:00") || (value.range.start === "24:00" && value.range.end === "00:00")) {
            return {valid: false , message: commonUtil.getMessageText(i18n, "error_validate_invalid_time_range_format")};
        }

        return {valid: true , message: ""};
    }
}
